// ─────────────────────────────────────────────
// permissions — FE gating by the user's effective CASL abilities
//
// GET /users/me returns the role's rules as flat {action, subject} pairs
// (S-121 follow-up / DEC-WP24-e). The backend stays the enforcer; this only
// decides which controls to RENDER, so custom roles see exactly the buttons
// their policy allows instead of being matched by role name.
// ─────────────────────────────────────────────

export interface UserAbility {
  action: string;
  subject: string;
}

interface AbilityHolder {
  role?: string;
  abilities?: UserAbility[];
}

/**
 * True when the user's policy grants `action` on `subject`.
 * CASL semantics: `manage` covers every action, subject `all` covers every
 * subject. Sessions persisted before abilities existed fall back to the old
 * Org Admin role-name check until the next login/profile refresh.
 */
export function userCan(user: AbilityHolder | null | undefined, action: string, subject: string): boolean {
  if (!user) return false;
  if (user.abilities && user.abilities.length > 0) {
    return user.abilities.some(
      (r) =>
        (r.subject === subject || r.subject === "all") &&
        (r.action === action || r.action === "manage")
    );
  }
  return user.role === "Org Admin";
}
